import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { isEmpty, isUndefined } from 'lodash';
import React, { useMemo } from 'react';

/**
 * Field: Version
 *
 * This field is used to display the version of the entity, with options to select a different version.
 *
 * @param criteriaVersions
 * @param currentEntity
 * @returns {Element}
 * @constructor
 */
export function Version({ criteriaVersions = [], currentEntity = {} }) {
  const versionOptions = useMemo(() => {
    const theVersions = [];

    if (!isUndefined(criteriaVersions) && !isEmpty(criteriaVersions)) {
      criteriaVersions?.forEach((criteriaVersion) => {
        const isCurrent = criteriaVersion?.version === currentEntity?.activeVersionNbr;

        theVersions.push({
          label: `v${criteriaVersion?.version} ${isCurrent ? '(Current)' : ''}`,
          value: criteriaVersion?.version,
        });
      });
    }

    return theVersions;
  }, [criteriaVersions, currentEntity]);

  return (
    <ErrorHandler location="src/entities/Criteria/ui/components/fields/Version/Version.jsx">
      <div
        style={{
          width: `${Number(themeConfiguration?.theme?.space?.xl?.replace('px', '')) * 3}px`,
        }}
      >
        <SelectInput label="Version" model="version" options={versionOptions} />
      </div>
    </ErrorHandler>
  );
}
